var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 220,
    height: 46.404,
    viewBox: "0 0 220 46.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_5021",
    "data-name": "Rettangolo 5021",
    width: 220,
    height: 46.404,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4329",
    "data-name": "Raggruppa 4329",
    transform: "translate(610 -19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4328",
    "data-name": "Raggruppa 4328",
    transform: "translate(-610 19)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19677",
    "data-name": "Tracciato 19677",
    d: "M26.268,14.734A.958.958,0,0,0,25.2,13.9a.932.932,0,0,0-.586.3l.194.18a.787.787,0,0,0,.853.984,1.172,1.172,0,0,0,.166-.039l.191.174a.952.952,0,0,0,.25-.765",
    transform: "translate(3.491 1.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19678",
    "data-name": "Tracciato 19678",
    d: "M86.65,20.865l-2.463-2.7a6.626,6.626,0,0,1-4.3,1.467,5.43,5.43,0,0,1-4.018-1.517,5.521,5.521,0,0,1-1.541-4.09,5.267,5.267,0,0,1,5.534-5.5,6.8,6.8,0,0,1,4.325,1.482l2.463-2.7a10,10,0,0,0-6.788-2.462,9.07,9.07,0,0,0-9.23,9.209,9.072,9.072,0,0,0,9.23,9.278,9.949,9.949,0,0,0,6.788-2.469",
    transform: "translate(10.017 0.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19679",
    "data-name": "Tracciato 19679",
    d: "M118.217,23.333,125.6,4.846h-3.943L116.3,18.391l-5.25-13.545h-3.94l7.406,18.487Z",
    transform: "translate(15.191 0.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19680",
    "data-name": "Tracciato 19680",
    d: "M159.54,23.333V19.882h-9.864V4.846h-3.693V23.333Z",
    transform: "translate(20.703 0.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19681",
    "data-name": "Tracciato 19681",
    d: "M175.218,23.333V19.882h-9.861V4.846h-3.7V23.333Z",
    transform: "translate(22.926 0.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19682",
    "data-name": "Tracciato 19682",
    d: "M192.322,20.682a8.944,8.944,0,0,0,2.649-6.592,9.245,9.245,0,1,0-18.489,0,9.327,9.327,0,0,0,15.84,6.592M189.734,9.959a5.86,5.86,0,0,1,1.539,4.131,5.859,5.859,0,0,1-1.539,4.13,5.658,5.658,0,0,1-8.012,0,5.859,5.859,0,0,1-1.539-4.13,5.86,5.86,0,0,1,1.539-4.131,5.669,5.669,0,0,1,8.012,0",
    transform: "translate(25.029 0.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19683",
    "data-name": "Tracciato 19683",
    d: "M92.345,23.333,93.454,20.5h8.381l1.11,2.836,3.934-.011L99.494,4.846H93.943l.92,2.335L88.4,23.333Zm8.134-6.532H94.93l2.816-7.023Z",
    transform: "translate(12.537 0.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19684",
    "data-name": "Tracciato 19684",
    d: "M56.1,23.333,57.21,20.5h8.382L66.7,23.333l3.932-.011L63.249,4.846H57.7l.924,2.335L52.155,23.333ZM64.234,16.8H58.687L61.5,9.778Z",
    transform: "translate(7.397 0.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19685",
    "data-name": "Tracciato 19685",
    d: "M130.188,23.333,131.3,20.5h8.379l1.11,2.836,3.932-.011L137.338,4.846h-5.556l.925,2.335-6.462,16.152Zm8.134-6.532h-5.544l2.808-7.023Z",
    transform: "translate(17.904 0.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_5020",
    "data-name": "Rettangolo 5020",
    width: 1.306,
    height: 5.941,
    transform: "translate(77.435 34.829)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19686",
    "data-name": "Tracciato 19686",
    d: "M74.81,36.445a3.406,3.406,0,0,0,1.278-.232,3.069,3.069,0,0,0,1-.627,2.814,2.814,0,0,0,.649-.942,3.075,3.075,0,0,0,.228-1.173v-.017a3.023,3.023,0,0,0-.228-1.166,2.8,2.8,0,0,0-.649-.941,3.053,3.053,0,0,0-1-.62A3.521,3.521,0,0,0,74.81,30.5H72.49v5.941Zm.731-4.631a1.6,1.6,0,0,1,.563.368,1.833,1.833,0,0,1,.37.569,2.044,2.044,0,0,1,.126.722v.017a1.989,1.989,0,0,1-.126.724,1.8,1.8,0,0,1-.37.558,1.543,1.543,0,0,1-.563.364,1.989,1.989,0,0,1-.731.127H73.8V31.68H74.81a1.967,1.967,0,0,1,.731.134",
    transform: "translate(10.28 4.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19687",
    "data-name": "Tracciato 19687",
    d: "M85.049,36.444V35.281H81.827V34.032h2.8V32.866h-2.8v-1.2H85.01V30.5H80.536v5.941Z",
    transform: "translate(11.421 4.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19688",
    "data-name": "Tracciato 19688",
    d: "M88.634,36.45l.546-1.334h2.512l.54,1.334H93.6l-2.545-5.987h-1.2L87.3,36.45Zm2.59-2.489H89.64l.795-1.926Z",
    transform: "translate(12.381 4.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19689",
    "data-name": "Tracciato 19689",
    d: "M98.9,36.421a2.077,2.077,0,0,0,.685-.363,1.634,1.634,0,0,0,.449-.574,1.86,1.86,0,0,0,.158-.788v-.018a1.7,1.7,0,0,0-.122-.669,1.373,1.373,0,0,0-.368-.485,2.253,2.253,0,0,0-.594-.357,5.906,5.906,0,0,0-.8-.269c-.261-.065-.469-.127-.638-.176a2,2,0,0,1-.4-.163.469.469,0,0,1-.2-.191.523.523,0,0,1-.055-.251V32.1a.468.468,0,0,1,.19-.369.976.976,0,0,1,.575-.145,1.98,1.98,0,0,1,.763.158,4.883,4.883,0,0,1,.783.425l.678-.982a3.574,3.574,0,0,0-1-.563,3.654,3.654,0,0,0-1.2-.2,2.7,2.7,0,0,0-.84.13,1.94,1.94,0,0,0-.652.367,1.643,1.643,0,0,0-.426.563,1.714,1.714,0,0,0-.154.738v.016a1.715,1.715,0,0,0,.143.739,1.359,1.359,0,0,0,.394.5,2.358,2.358,0,0,0,.619.336,8.281,8.281,0,0,0,.821.247,6.292,6.292,0,0,1,.609.179,1.782,1.782,0,0,1,.367.168.509.509,0,0,1,.182.183.6.6,0,0,1,.043.224v.017a.473.473,0,0,1-.225.414,1.164,1.164,0,0,1-.635.145,2.278,2.278,0,0,1-.936-.193,3.857,3.857,0,0,1-.836-.526l-.772.923a3.541,3.541,0,0,0,1.187.72,4,4,0,0,0,1.335.235,3.125,3.125,0,0,0,.88-.121",
    transform: "translate(13.544 4.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19690",
    "data-name": "Tracciato 19690",
    d: "M108.607,36.444V34.139h2.834V32.963h-2.834V31.679h3.215V30.5H107.3v5.941Z",
    transform: "translate(15.217 4.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19691",
    "data-name": "Tracciato 19691",
    d: "M118.595,36.314a2.967,2.967,0,0,0,1-.665,3.036,3.036,0,0,0,.9-2.165v-.018a3.017,3.017,0,0,0-.233-1.193,2.963,2.963,0,0,0-.654-.967,3.045,3.045,0,0,0-1-.651,3.227,3.227,0,0,0-1.262-.242,3.262,3.262,0,0,0-1.269.242,3.034,3.034,0,0,0-1.9,2.829V33.5a3,3,0,0,0,.235,1.2,2.885,2.885,0,0,0,.651.966,3.1,3.1,0,0,0,1,.652,3.175,3.175,0,0,0,1.262.243,3.238,3.238,0,0,0,1.272-.243m-.548-4.549a1.952,1.952,0,0,1,.573.4,1.751,1.751,0,0,1,.37.6,1.917,1.917,0,0,1,.134.723V33.5a1.881,1.881,0,0,1-.134.718,1.754,1.754,0,0,1-.364.589,1.688,1.688,0,0,1-.564.4,1.805,1.805,0,0,1-.719.143,1.767,1.767,0,0,1-.726-.148,1.8,1.8,0,0,1-.569-.4,1.853,1.853,0,0,1-.376-.595,2.029,2.029,0,0,1-.129-.72v-.018a1.993,1.993,0,0,1,.129-.717,2.033,2.033,0,0,1,.365-.591,1.7,1.7,0,0,1,.565-.4,1.831,1.831,0,0,1,1.444,0",
    transform: "translate(16.192 4.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19692",
    "data-name": "Tracciato 19692",
    d: "M124.259,36.445v-1.9h1.03l1.272,1.9h1.529l-1.448-2.123a2.086,2.086,0,0,0,.919-.668,1.872,1.872,0,0,0,.348-1.175v-.016a1.84,1.84,0,0,0-.5-1.36,2.355,2.355,0,0,0-1.733-.6h-2.715v5.941Zm2.058-4.551a.759.759,0,0,1,.274.638v.014a.766.766,0,0,1-.263.611,1.075,1.075,0,0,1-.742.233h-1.327V31.68h1.3a1.212,1.212,0,0,1,.758.214",
    transform: "translate(17.437 4.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19693",
    "data-name": "Tracciato 19693",
    d: "M136.325,36.444V34.057h2.412v2.388h1.31V30.5h-1.31V32.85h-2.412V30.5H135.02v5.941Z",
    transform: "translate(19.148 4.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19694",
    "data-name": "Tracciato 19694",
    d: "M147.087,36.314a2.988,2.988,0,0,0,1-.665,3.124,3.124,0,0,0,.661-.973,3.015,3.015,0,0,0,.232-1.192v-.018a2.952,2.952,0,0,0-.884-2.16,3.021,3.021,0,0,0-1-.651,3.433,3.433,0,0,0-2.533,0,3.052,3.052,0,0,0-1,.658,3.133,3.133,0,0,0-.655.979,3.025,3.025,0,0,0-.239,1.193V33.5a3.184,3.184,0,0,0,.231,1.2,2.946,2.946,0,0,0,.654.966,3.154,3.154,0,0,0,1,.652,3.424,3.424,0,0,0,2.535,0m-.547-4.549a1.973,1.973,0,0,1,.574.4,1.811,1.811,0,0,1,.372.6,1.961,1.961,0,0,1,.131.723V33.5a1.932,1.932,0,0,1-.493,1.307,1.712,1.712,0,0,1-1.288.544,1.756,1.756,0,0,1-.726-.148,1.734,1.734,0,0,1-.57-.4,1.887,1.887,0,0,1-.373-.595,1.982,1.982,0,0,1-.132-.72v-.018a1.947,1.947,0,0,1,.132-.717,1.842,1.842,0,0,1,.368-.591,1.657,1.657,0,0,1,.558-.4,1.837,1.837,0,0,1,1.447,0",
    transform: "translate(20.233 4.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19695",
    "data-name": "Tracciato 19695",
    d: "M152.755,36.445v-1.9h1.025l1.275,1.9h1.527l-1.447-2.123a2.04,2.04,0,0,0,.915-.668,1.833,1.833,0,0,0,.354-1.175v-.016a1.841,1.841,0,0,0-.507-1.36,2.35,2.35,0,0,0-1.731-.6h-2.718v5.941Zm2.053-4.551a.755.755,0,0,1,.273.638v.014a.773.773,0,0,1-.257.611,1.086,1.086,0,0,1-.746.233h-1.323V31.68h1.3a1.2,1.2,0,0,1,.756.214",
    transform: "translate(21.478 4.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19696",
    "data-name": "Tracciato 19696",
    d: "M162.105,36.421a2.054,2.054,0,0,0,.683-.363,1.627,1.627,0,0,0,.451-.574,1.9,1.9,0,0,0,.158-.788v-.018a1.584,1.584,0,0,0-.126-.669,1.321,1.321,0,0,0-.363-.485,2.193,2.193,0,0,0-.6-.357,5.473,5.473,0,0,0-.8-.269c-.253-.065-.467-.127-.636-.176a2.043,2.043,0,0,1-.394-.163.46.46,0,0,1-.2-.191.566.566,0,0,1-.054-.251V32.1a.46.46,0,0,1,.191-.369.969.969,0,0,1,.574-.145,1.983,1.983,0,0,1,.762.158,4.916,4.916,0,0,1,.781.425l.679-.982a3.57,3.57,0,0,0-1.007-.563,3.615,3.615,0,0,0-1.2-.2,2.684,2.684,0,0,0-.843.13,1.973,1.973,0,0,0-.657.367,1.687,1.687,0,0,0-.426.563,1.763,1.763,0,0,0-.147.738v.016a1.717,1.717,0,0,0,.138.739,1.333,1.333,0,0,0,.4.5,2.272,2.272,0,0,0,.617.336,8.284,8.284,0,0,0,.821.247,6.2,6.2,0,0,1,.609.179,1.8,1.8,0,0,1,.365.168.511.511,0,0,1,.177.183.5.5,0,0,1,.046.224v.017a.471.471,0,0,1-.223.414,1.154,1.154,0,0,1-.631.145,2.272,2.272,0,0,1-.94-.193,3.892,3.892,0,0,1-.837-.526l-.771.923a3.563,3.563,0,0,0,1.188.72,4,4,0,0,0,1.331.235,3.123,3.123,0,0,0,.883-.121",
    transform: "translate(22.507 4.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19697",
    "data-name": "Tracciato 19697",
    d: "M170.556,36.444V35.281H167.33V34.032h2.8V32.866h-2.8v-1.2h3.186V30.5h-4.478v5.941Z",
    transform: "translate(23.547 4.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19698",
    "data-name": "Tracciato 19698",
    d: "M176.306,36.421a2.071,2.071,0,0,0,.684-.363,1.63,1.63,0,0,0,.448-.574,1.9,1.9,0,0,0,.161-.788v-.018a1.657,1.657,0,0,0-.127-.669,1.367,1.367,0,0,0-.365-.485,2.206,2.206,0,0,0-.595-.357,5.7,5.7,0,0,0-.8-.269c-.257-.065-.469-.127-.636-.176a2,2,0,0,1-.4-.163.5.5,0,0,1-.2-.191.551.551,0,0,1-.051-.251V32.1a.46.46,0,0,1,.191-.369.973.973,0,0,1,.573-.145,2,2,0,0,1,.764.158,5.13,5.13,0,0,1,.782.425l.681-.982a3.44,3.44,0,0,0-2.212-.759,2.68,2.68,0,0,0-.84.13,1.991,1.991,0,0,0-.653.367,1.672,1.672,0,0,0-.426.563,1.712,1.712,0,0,0-.151.738v.016a1.77,1.77,0,0,0,.138.739,1.386,1.386,0,0,0,.4.5,2.26,2.26,0,0,0,.62.336,8.24,8.24,0,0,0,.815.247,5.871,5.871,0,0,1,.61.179,1.814,1.814,0,0,1,.364.168.5.5,0,0,1,.18.183.5.5,0,0,1,.047.224v.017a.476.476,0,0,1-.223.414,1.174,1.174,0,0,1-.635.145,2.265,2.265,0,0,1-.937-.193,3.777,3.777,0,0,1-.836-.526l-.775.923a3.555,3.555,0,0,0,1.191.72,4.016,4.016,0,0,0,1.333.235,3.153,3.153,0,0,0,.883-.121",
    transform: "translate(24.52 4.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19699",
    "data-name": "Tracciato 19699",
    d: "M23.9,1.8c1.391,0,6.518.794,14.048,11l.3-.21C33.135,4.71,27.767,0,23.9,0S14.669,4.711,9.547,12.6l.3.211C17.383,2.6,22.509,1.8,23.9,1.8",
    transform: "translate(1.354 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19700",
    "data-name": "Tracciato 19700",
    d: "M16.341,42.524c-1.31-.074-12.834-.82-14.256-4-.883-2.006-.87-7.141,1.241-13.676l-.347-.123C-.069,32.725-.783,37.881.86,40.057c.913,1.12,3.858,1.959,8.515,2.428,2.024.2,4.361.339,6.95.409Z",
    transform: "translate(0 3.506)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19701",
    "data-name": "Tracciato 19701",
    d: "M36.892,42.487c4.655-.467,7.6-1.305,8.517-2.431,1.64-2.172.926-7.328-2.122-15.327l-.347.122c2.112,6.536,2.123,11.673,1.238,13.68-1.416,3.175-12.943,3.922-14.251,4l.015.369c2.592-.069,4.932-.2,6.95-.41",
    transform: "translate(4.244 3.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19702",
    "data-name": "Tracciato 19702",
    d: "M24.331,25.355c7.751,0,17.474,12.51,17.573,12.638l.264-.188a67.022,67.022,0,0,0-5.9-7.553c-4.591-5.034-8.608-7.584-11.94-7.584s-7.35,2.55-11.939,7.584a66.889,66.889,0,0,0-5.9,7.553l.264.188c.1-.128,9.823-12.638,17.574-12.638",
    transform: "translate(0.921 3.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19703",
    "data-name": "Tracciato 19703",
    d: "M13.966,29.2a13.719,13.719,0,0,1,10.748-18.95l.434-.07a2.454,2.454,0,0,1,1.2-.308,2.193,2.193,0,0,1,1.093.285l-1.454,1.853,3.075,2.848.058.472,6.353,5.883a.473.473,0,0,1,.148.292.633.633,0,0,1,0,.082l-.035,1.092-1.708.572a.7.7,0,0,1-.14.033.655.655,0,0,1-.6-.259l-.5-.673-4.667-2.216-.282.162a2.977,2.977,0,0,1-1.482.394,2.976,2.976,0,0,1-2.952-2.617l-.323.024c.054,2.435,1.65,4.066,3.785,3.807a4.2,4.2,0,0,0,1.294-.372l3.81,1.807.314.424a1.9,1.9,0,0,0,1.75.754,1.931,1.931,0,0,0,.4-.09l1.771-.595a1.111,1.111,0,0,0,.772-1.046l.037-1.158a2,2,0,0,0-.011-.275,1.718,1.718,0,0,0-.541-1.056L30.3,14.732l-.057-.473-2.569-2.378L29.2,9.932l-.788-.614a2.146,2.146,0,0,0-1.3-.361,2.682,2.682,0,0,0-2.135.932A14.643,14.643,0,0,0,12,31.162c.628-.663,1.287-1.322,1.966-1.957",
    transform: "translate(1.477 1.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19704",
    "data-name": "Tracciato 19704",
    d: "M35.342,31.788l-.268-.252A13.721,13.721,0,0,1,14.935,28.8c-.683.526-1.35,1.081-1.99,1.643a14.641,14.641,0,0,0,22.4,1.34",
    transform: "translate(1.836 4.085)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dd6faea32949db435dd45b553f2bd6a7.svg";
export { ForwardRef as ReactComponent };